export default __webpack_public_path__ + "static/media/nova_entrada.b8e9a3ef.jpeg";